<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        首页公告
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" class="content1">
      <template>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="title" label="标题" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <button @click="notice(scope.row.id)" class="button1">编辑</button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <noAccess v-else></noAccess>
    <el-dialog title="编辑首页公告" :visible.sync="dialogFormVisible2" width="47%">
      <el-form>
        <el-form-item label="标题:">
          <el-input style="width:356px" v-model="red_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="封面:">
          <el-upload
            action
            list-type="picture-card"
            :auto-upload="false"
            :limit="1"
            :on-change="red_coverChange"
            :file-list="red_cover"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div>
            内容:
            <wanged-itor :info="red_content" @change_edit="change_edit"></wanged-itor>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitRedact()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WangedItor from "../components/wangeditor";
export default {
  components: {
    WangedItor
  },
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      wang_edit: null,
      red_title: "",
      red_content: "",
      red_cover: [],
      dialogFormVisible2: false,
      tableData: [],
      username: "",
      token: "",
      red_file: {},
      id: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 7;
    this.$store.state.leftTitle = "首页公告";
    this.geting();
  },

  methods: {
    change_edit(data) {
      this.wang_edit = data;
    },
    handimg(file, Editor, cursorLocation, resetUploader) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData();
      formData.append("img", file);
      formData.append("username", this.username);
      formData.append("token", this.token);
      this.axios
        .post(
          this.serve+"/admin/edit_upload_img",
          formData,
          config
        )
        .then(res => {
          Editor.insertEmbed(cursorLocation, "image", res.data.data);
          resetUploader();
        });
    },
    submitRedact() {
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("id", this.id);
      if (this.wang_edit === null) {
        formData.append("content", this.red_content);
      } else {
        formData.append("content", this.wang_edit);
      }
      formData.append("cover", this.red_file);
      this.axios
        .post(this.serve+"/admin/edit_notice", formData)
        .then(res => {
          if (res.data.status == "success") {
            this.dialogFormVisible2 = false;

            this.$message({
              type: "success",
              message: "编辑成功"
            });
            this.geting();
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    red_coverChange(file) {
      this.red_file = file.raw;
    },
    notice(id) {
      this.id = id;
      this.dialogFormVisible2 = true;
      this.axios
        .get(this.serve+"/admin/notice_detail", {
          params: {
            username: this.username,
            token: this.token,
            id
          }
        })
        .then(res => {
          this.red_cover = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            this.red_title = json.title;
            this.red_content = json.content;
            this.red_cover.push({
              url: this.serve+"" + json.cover
            });
          }
        });
    },
    geting() {
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/home_index_notice", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.tableData = res.data.data;
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.list {
  background: #f5f5f5;
  color: #333;
  // padding-bottom: 100px;
  min-height: 1000px;
  .content1 {
    //  background: #999;
    width: 1056px;
    margin: 0 auto;
    height: 500px;
    > span {
      margin-top: 20px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>